import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ThemeService } from '../../services/theme.service';

export interface Config {
  status: string;
  userID: string;
  username: string;
  password: string;
  sessionId: string;
}

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {
  themeList: any;
  signInLabel: string;
  usernamePlaceholder: string;
  passwordPlaceholder: string;
  signUpButtonLabel: string;
  noAccountLabel: string;
  forgotPasswordButtonLabel: string;
  pleaseSignInMessage: string;

  // userId: string;
  // username: string;


  constructor(public authService: AuthService, public themeService: ThemeService) {

    this.themeService.getThemeList().once('value', themeSnapshot => {
      this.themeList = [];
      themeSnapshot.forEach(snap => {
        this.themeList.push({
          companyLogo: snap.val().baseurl + snap.val().logo
        });
      });
    });

    this.themeService.getAuthorizationSettings().once('value', snapshot => {
      this.signInLabel = snapshot.val().sign_in_label;
      this.usernamePlaceholder = snapshot.val().username_placeholder;
      this.passwordPlaceholder = snapshot.val().password_placeholder;
      this.signUpButtonLabel = snapshot.val().sign_up_button_label;
      this.noAccountLabel = snapshot.val().no_account_label;
      this.forgotPasswordButtonLabel = snapshot.val().forgot_password_button_label;
      this.pleaseSignInMessage = snapshot.val().please_sign_in;

    });
  }

  ngOnInit() {}

  userSignIn(email, password) {
    this.authService.SignIn(email, password);
  }

  getProfile() {
    this.authService.getJoomlaUserProfile().subscribe(response => {
      console.log(response);
    });
  }

}
